export const mockData = {
  company: {
    name: "Prestige Events",
    tagline: "Crafting Unforgettable Experiences",
    description: "Thailand's premier luxury event company, specializing in bespoke events, talent booking, and media production. We transform visions into extraordinary realities.",
    contact: {
      phone: "+66 972341924",
      email: "info@prestigeevents.co.th",
      address: "No. 25, Alma Link Building, 17th Floor, Room No. 558, Soi Chidlom Phloenchit Road, Lumphini Subdistrict, Bangkok, Thailand",
      social: {
        facebook: "https://facebook.com/prestigeevents",
        instagram: "https://www.instagram.com/prestige.events_thailand?igsh=Ym9meng2Mmxjc2V4",
        linkedin: "https://linkedin.com/company/prestigeevents"
      }
    }
  },
  
  services: [
    {
      id: 1,
      title: "Events & Exhibitions",
      icon: "Sparkles",
      description: "From intimate gatherings to grand celebrations, we conceptualize and execute flawless events that leave lasting impressions.",
      features: [
        "Live Concerts & Entertainment",
        "MICE (National & International)",
        "Corporate Events & Brand Activations",
        "Product Launches & Gala Dinners",
        "Beach & Destination Weddings",
        "Dealer Meets & Conferences"
      ],
      image: "/JB2.jpg"
    },
    {
      id: 2,
      title: "Talent Booking",
      icon: "Users",
      description: "Access to an exclusive network of national and international celebrities, influencers, and artists for your event.",
      features: [
        "Celebrity & Influencer Management",
        "National & International Artists",
        "Artist Liaison & Coordination",
        "Private & Corporate Event Talent",
        "Entertainment Curation",
        "Contract Negotiation"
      ],
      image: "/talent.png"
    },
    {
      id: 3,
      title: "Media & Production",
      icon: "Film",
      description: "Full-spectrum media services from concept to delivery, creating compelling visual narratives for your brand.",
      features: [
        "TV Commercials & Digital Films",
        "Corporate Videos & Web Series",
        "Audio & Jingle Production",
        "Professional Scripting",
        "High-End Photoshoots",
        "Post-Production Excellence"
      ],
      image: "/m&P.jpg"
    }
  ],
  
  projects: [
    {
      id: 1,
      title: "Phuket, Thailand",
      category: "Event Conference",
      description: "International corporate conference in Phuket",
      image: "/PC19.jpg"
    },
    {
      id: 2,
      title: "Phuket, Thailand",
      category: "Event Conference",
      description: "International corporate conference in Phuket",
      image: "/PC1.jpg"
    },
    {
      id: 3,
      title: "Phuket, Thailand",
      category: "Event Conference",
      description: "International corporate conference in Phuket",
      image: "/PC2.jpg"
    },
    {
      id: 4,
      title: "Phuket, Thailand",
      category: "Event Conference",
      description: "International corporate conference in Phuket",
      image: "/PC3.jpg"
    },
    {
      id: 5,
      title: "Phuket, Thailand",
      category: "Event Conference",
      description: "International corporate conference in Phuket",
      image: "/PC7.jpg"
    },
    {
      id: 6,
      title: "Phuket, Thailand",
      category: "Event Conference",
      description: "International corporate conference in Phuket",
      image: "/PC8.jpg"
    },
    {
      id: 7,
      title: "Phuket, Thailand",
      category: "Event Conference",
      description: "International corporate conference in Phuket",
      image: "/PC10.jpg"
    },
    {
      id: 8,
      title: "Phuket, Thailand",
      category: "Event Conference",
      description: "International corporate conference in Phuket",
      image: "/PC11.jpg"
    },
    {
      id: 9,
      title: "Phuket, Thailand",
      category: "Event Conference",
      description: "International corporate conference in Phuket",
      image: "/PC12.jpg"
    },
    {
      id: 10,
      title: "Phuket, Thailand",
      category: "Event Conference",
      description: "International corporate conference in Phuket",
      image: "/PC16.jpg"
    },
    {
      id: 11,
      title: "Phuket, Thailand",
      category: "Event Conference",
      description: "International corporate conference in Phuket",
      image: "/PC14.jpg"
    },
    {
      id: 12,
      title: "Phuket, Thailand",
      category: "Event Conference",
      description: "International corporate conference in Phuket",
      image: "/PC17.jpg"
    },
    {
      id: 13,
      title: "Phuket, Thailand",
      category: "Event Conference",
      description: "International corporate conference in Phuket",
      image: "/PC18.jpg"
    },
    {
      id: 14,
      title: "Celebrity Socials",
      category: "Talent Booking",
      description: "Celebrity Socials",
      image: "/yp 3 Ranveer Singh.jpg"
    },
    {
      id: 15,
      title: "Birthday & Anniversary",
      category: "Celebrations",
      description: "",
      image: "/celebrations 1.jpg"
    },
    {
      id: 16,
      title: "Romantic Walkway Installation",
      category: "Wedding",
      description: "A breathtaking pathway lined with lanterns leading to the ceremony location.",
      image: "/view sunset.avif"
    },
    {
      id: 17,
      title: "Web-Series",
      category: "Media Production",
      description: "Postcards on Netflix",
      image: "/postcards series.jpg"
    },
    {
      id: 18,
      title: "Brand Activation",
      category: "Celebrity Shoots",
      description: "",
      image: "/ittehad priyanka.jpg"
    },
    {
      id: 19,
      title: "Glam Nite",
      category: "Luxury & Grandeur",
      description: "",
      image: "/Forever Glam 1.jpg"
    },
    {
      id: 20,
      title: "Meri Kahani Album",
      category: "Music Production",
      description: "",
      image: "/Meri Kahani Music Video.jpg"
    },
    {
      id: 21,
      title: "Musical Concert",
      category: "Talent Booking",
      description: "",
      image: "/JB1.jpg"
    }
  ],
  
  testimonials: [
    {
      id: 1,
      name: "Rajeev Verma",
      position: "Well Freight Pvt. Ltd.",
      content: "For years, our company has been organizing events in Bangkok, hosting as many as six events annually, due to its strategic location as a well-connected international hub. However, this time, due to our longstanding vendor's prior commitments, we were introduced to Prestige Event Co. Ltd.—and to our pleasant surprise, everything went perfectly.\n\nDespite being a newer team, Prestige Event Co. Ltd., led by the dedicated and professional Ms. Ava, managed to deliver an exceptional event that exceeded all expectations. From the venue selection to the logistics and on-the-ground support, the team ensured that everything was flawlessly executed.\n\nAs a result, we are now confident that for all future events in Thailand, we have found the right partner. We look forward to working with Prestige Event Co. Ltd. on many more successful events moving forward!",
      rating: 5,
      image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400"
    },
    {
      id: 2,
      name: "Pankaj Shukla",
      position: "Transtech Shipping & Logistics Pvt. Ltd.",
      content: "We assigned the organization of our annual award ceremony to Prestige Event Co. Ltd. at the very last moment, based on a friend's recommendation—and we are delighted to say that everything turned out outstanding. Despite the short notice, every aspect was managed exceptionally well, from the team's arrival and hotel arrangements to the auditorium setup and various fun events.\n\nThe entire Transtech team is deeply thankful to the Prestige Team, and especially to Ms. Ava, for her round-the-clock availability and dedication in making the event a great success.\n\nKeep up the excellent work, and we look forward to collaborating with you again!",
      rating: 5,
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400"
    },
    {
      id: 3,
      name: "Mr. Abhijit Bankhele",
      position: "M.D. - Advantek Air Systems Pvt. Ltd.",
      content: "Participating in ACREX Global HVAC expo came with high expectations — and Prestige Events Co. Ltd. exceeded every one of them. They created a striking, modern exhibition stall that not only reflected our brand's identity but also attracted tremendous footfall throughout the event. Their commitment to precision, timelines, and quality craftsmanship ensured a smooth build and an even smoother show day. We're proud to have had them as our partner.",
      rating: 5,
      image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400"
    },
    {
      id: 4,
      name: "Mr. Pramod Panchal",
      position: "Director - J. K. Industries",
      content: "From the very first meeting, the Prestige Events Co. Ltd. team demonstrated a deep understanding of our company's values and objectives. Their seamless coordination, attention to detail, and creative execution turned our annual conference into a world-class experience. Every guest walked away impressed and so did we. They truly made our vision come alive.",
      rating: 5,
      image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400"
    },
    {
      id: 5,
      name: "Mr. Pravin Shetty",
      position: "Director - Pharmintech Turnkey Solutions Pvt. Ltd.",
      content: "We partnered with Prestige Events for the high-stakes launch of our latest HVAC line. Instead of a basic booth, they curated a complete experiential zone, from live technical demos to immersive branding touchpoints. Their team understood both our audience and our tech. The final execution was world-class, drawing decision-makers straight to us and leaving a strong impression. Truly a partner who delivers with precision.",
      rating: 5,
      image: "https://images.unsplash.com/photo-1556157382-97eda2d62296?w=400"
    },
    {
      id: 6,
      name: "Praveen Mishra",
      position: "Sales Head",
      content: "Working with Prestige Events Co. Ltd. has been a game-changer for our sales initiatives. Their team's ability to understand our business objectives and translate them into impactful event experiences is truly remarkable. From product showcases to client engagement events, every detail was handled with utmost professionalism and creativity.\n\nThe Prestige team, especially Ms. Ava, ensured seamless coordination throughout, making our events not just memorable but highly effective in driving business results. Their attention to detail and commitment to excellence has made them our go-to partner for all event requirements.\n\nWe highly recommend Prestige Events Co. Ltd. and look forward to a long and successful partnership ahead!",
      rating: 5,
      image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400"
    }
  ],
  
  stats: [
    { label: "Events Executed", value: "500+" },
    { label: "Years of Excellence", value: "12+" },
    { label: "Happy Clients", value: "350+" },
    { label: "Industry Awards", value: "25+" }
  ]
};